/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_Titlelabel1Inputs */

const he_account_reviews_titlelabel1 = /** @type {(inputs: Account_Reviews_Titlelabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כותרת (אופציונלי)`)
};

const en_account_reviews_titlelabel1 = /** @type {(inputs: Account_Reviews_Titlelabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title (optional)`)
};

/**
* | output |
* | --- |
* | "Title (optional)" |
*
* @param {Account_Reviews_Titlelabel1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const account_reviews_titlelabel1 = /** @type {((inputs?: Account_Reviews_Titlelabel1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_Titlelabel1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_titlelabel1(inputs)
	return en_account_reviews_titlelabel1(inputs)
});
export { account_reviews_titlelabel1 as "account_reviews_titleLabel" }